export type PuckAccessLevel = "public" | "subscribed";

export const DEFAULT_PUCK_ACCESS_LEVEL: PuckAccessLevel = "public";

export function normalizePuckAccessLevel(value: unknown): PuckAccessLevel {
  return value === "subscribed" ? "subscribed" : "public";
}
